import React from "react";
import "./style.scss";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import IconLink from "../../elements/icon-link";
import classNames from "classnames";

const SuggestedArticles = ({ heading, articles, linkIcon, className }) => {
  const componentClassNames = classNames("suggested-articles", className);
  return (
    <div className={componentClassNames}>
      {heading && <Heading html={heading.text} type={heading.type} className="title" typographyClass="type-h3" />}
      {articles.map((article, index) => {
        return (
          <IconLink
            {...{
              buttonText: article.title,
              iconName: linkIcon,
              className: "white",
              link: article.link
            }}
            key={index}
          />
        );
      })}
    </div>
  );
};

SuggestedArticles.propTypes = {
  heading: PropTypes.shape({
    type: PropTypes.object,
    html: PropTypes.string,
    typographyClass: PropTypes.string
  }),
  linkIcon: PropTypes.shape({ svg: PropTypes.string }),
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      link: PropTypes.object
    })
  )
};

SuggestedArticles.defaultProps = {
  articles: []
};

export default SuggestedArticles;
